export default __webpack_public_path__ + "static/matcap8-6ff81fb3d68ca040de0e575fc13a7033.jpg";